import React__default, { useState, useEffect } from 'react';
import cn from 'classnames';
import styles from 'ui-components/OffCanvasContainer.scss';
import { usePrevious } from '../../helpers/use-previous.js';

var ANIMATION_STATE = {
  HIDING: "hiding",
  HIDDEN: "hidden",
  ENTERING: "entering",
  ENTERED: "entered"
};
var OffCanvasContainer = function OffCanvasContainer(_ref) {
  var _cn, _cn2, _cn3, _cn4, _cn5, _cn6, _cn7;
  var id = _ref.id,
    isOpen = _ref.isOpen,
    close = _ref.close,
    children = _ref.children,
    className = _ref.className,
    _ref$side = _ref.side,
    side = _ref$side === void 0 ? "LEFT" : _ref$side;
  var _useState = useState(ANIMATION_STATE.HIDDEN),
    animationState = _useState[0],
    setAnimationState = _useState[1];
  var prevIsOpen = usePrevious(isOpen);
  var _close = function _close() {
    if (animationState === ANIMATION_STATE.ENTERING) {
      return null;
    }
    setAnimationState(ANIMATION_STATE.HIDING);
    close();
    setTimeout(function () {
      setAnimationState(ANIMATION_STATE.HIDDEN);
    }, parseInt(styles.animationDuration, 10));
  };
  useEffect(function () {
    if (isOpen) {
      setAnimationState(ANIMATION_STATE.ENTERING);
      setTimeout(function () {
        setAnimationState(ANIMATION_STATE.ENTERED);
      }, parseInt(styles.animationDuration, 10));
    } else if (prevIsOpen && !isOpen) {
      _close();
    }
  }, [isOpen]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.dim, (_cn = {}, _cn[styles.hidden] = animationState === ANIMATION_STATE.HIDDEN, _cn), (_cn2 = {}, _cn2[styles.hiding] = animationState === ANIMATION_STATE.HIDING, _cn2), (_cn3 = {}, _cn3[styles.entering] = animationState === ANIMATION_STATE.ENTERING, _cn3), (_cn4 = {}, _cn4[styles.entered] = animationState === ANIMATION_STATE.ENTERED, _cn4)),
    onClick: function onClick() {
      return _close();
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    id: id,
    className: cn(styles.container, (_cn5 = {}, _cn5[styles.hidden] = !isOpen, _cn5), (_cn6 = {}, _cn6[styles.left] = side === "LEFT", _cn6), (_cn7 = {}, _cn7[styles.right] = side === "RIGHT", _cn7), className)
  }, children));
};

export { OffCanvasContainer };
//# sourceMappingURL=index.js.map
